import script from "./OrderQueryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderQueryPage.vue?vue&type=script&setup=true&lang=js"

import "./OrderQueryPage.vue?vue&type=style&index=0&id=b59917b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b59917b8"]])

export default __exports__